export default "__VITE_ASSET__C9H7o9Fk__"